export default "__VITE_ASSET__CKd4dnfa__"